<div class="mb-3 mx-auto">
  <div class="bg-white rounded-3  shadow-sm overflow-hidden">
    <ng-container *ngFor="let metric of metrics">
      <pla-metric-graph *ngIf="metric && metric.data.length > 0"
                        [dataPoints]="metric.data"
                        [icon]="metric.icon"
                        [title]="metric.title"
                        [interaction]="metric.key"
                        [key]="metric.key"
                        [rgb]="metric.rgb"
                        [ordinalOptions]="metric.ordinalOptions"
      ></pla-metric-graph>
    </ng-container>
  </div>
  <div class="mt-1">
    <span class="w-100 text-muted d-block text-center">{{ description }}</span>
  </div>
</div>
